import { getToken } from './token'

const uploadConfig = {
  simpleUpload: {
    uploadUrl: `${process.env.REACT_APP_PLURALL_MS_UPLOAD_API}/image`,
    withCredentials: false,
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  },
}

export { default as Client } from './client.js'
export { getOauthClient } from './oauth'
export { getToken, setToken } from './token'
export { uploadConfig }
export { envPicker } from './environments'
